export default __webpack_public_path__ + "static/media/BH.fe1c165d.png";